import debug from 'debug';

const log = debug('BrowserSpecific');

class BrowserSpecific {
	static isIE() {
		var undef,
		v = 3,
		div = document.createElement('div'),
		all = div.getElementsByTagName('i');

		while (
			div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->',
			all[0]
		);

		if (v === 9) document.body.classList.add('is-ie9');

		return v > 4 ? v : undef;
	}

	static isIE11() {
		const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
		return isIE11;
	}
}

export default BrowserSpecific;
